<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: ESM Woocommerce to Hubspot Integration
      Author: Wibert Muza
    Agency URL: https://esminbound.com
========================================================================================== -->

<template>
  <div id="demo-basic-card">
    <div class="vx-row">
      <div
        class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base"
      >
        <vx-card>
          <div slot="no-body">
            <img
              :src="AppActiveUser.woocommerceImage"
              alt="content-img"
              class="responsive card-img-top"
            />
          </div>
          <h5 class="mb-2">{{ AppActiveUser.woocommerceTitle }}</h5>
          <p class="text-grey">Store URL: {{ AppActiveUser.cards.wooStoreUrl }}</p>
          <div class="flex justify-between flex-wrap">
            <vs-button
              class="mt-4 mr-2"
              color="warning"
              type="border"
              v-if="!AppActiveUser.cards.wooActive"
              @click="popupActive = true"
              >Connect</vs-button
            >
            <vs-button
              class="mt-4"
              color="danger"
              type="border"
              v-if="AppActiveUser.cards.wooActive"
              @click="updatecards()"
              >Disconnect</vs-button
            >
          </div>
        </vx-card>
      </div>
      
      <div class="demo-alignment">
        <vs-popup
          class="holamundo"
          title="Connect to Woocommerce"
          :active.sync="popupActive"
        >
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                name="storeUrl"
                label="Store URL"
                placeholder=""
                v-model="woocommerce"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full" style="text-align:center">
              <vs-button
                class="mr-3 mb-2 mt-5"
                v-on:click="wooConnection()"
                v-if="showButton"
                >Connect</vs-button
              >
              <vs-button class="mr-3 mb-2 mt-5" v-if="!showButton" disabled
                >Connect</vs-button
              >
            </div>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      popupActive: false,
      showButton: false,
    };
  },
  computed: {
    woocommerce: {
      get () {
        return this.$store.state.AppActiveUser.cards.wooStoreUrl
      },
      set (value) {
        this.$store.commit('UPDATE_STOREURL', value);
        if(value) this.showButton = true       
      }
    },
    ...mapState(['AppActiveUser'])
  },
  methods: {
    wooConnection: function() {
      var authwindow = window.open(
        this.AppActiveUser.woocommerceConnection +'&store_url='+this.AppActiveUser.cards.wooStoreUrl,
        "",
        "location=yes,scrollbars=yes,status=yes"
      );

      let cThis = this;
      var timer = setInterval(function() {
        if (authwindow.closed) {
          cThis.$store.dispatch("updateUserData");
          clearInterval(timer);          
          location.reload();
        }
      }, 1000);
    },
    checkSuccessWoocommerce: function(result) {
      if (result == 1 || result == 0) {
        window.open("", "_parent", "");
        window.close();
      }
    },
    updatecards: function() {  
      this.$store.commit('UPDATE_WOOCOMMERCE', false);
      let cThis = this;
      setTimeout(function() {  
        cThis.$store.dispatch('updateConnectionSendData', cThis.AppActiveUser.cards);  
      }, 200);     
    }
  },
  created() {
    this.checkSuccessWoocommerce(this.$route.query.success);
  }
};
</script>
